export const API_KEY = 'AIzaSyCtKrxXqq0_ASat6QpQgGWaJOxZm-EltBQ';
